import React, { useState, useEffect, useRef } from 'react';
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import CustomToast from "../../components/Toast";

const auctionDetailId =
  window.location.pathname &&
  window.location.pathname.split("/") &&
  window.location.pathname.split("/")[2]
    ? atob(
        window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[2]
      )
    : "";
const userId =
  window.location.pathname &&
  window.location.pathname.split("/") &&
  window.location.pathname.split("/")[3]
    ? atob(
        window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[3]
      )
    : "";

const MAX_RECONNECT_ATTEMPTS = 10;
const RECONNECT_INTERVAL = 5000; // 5 seconds

function YourComponent() {
  const dispatch = useDispatch();
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const stompClientRef = useRef(null);
  const socketRef = useRef(null);
  const reconnectTimerRef = useRef(null);

  const connectWebSocket = () => {
    // Clear any existing reconnect timer
    if (reconnectTimerRef.current) {
      clearTimeout(reconnectTimerRef.current);
    }

    // Check if we've exceeded max reconnect attempts
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      CustomToast.error(`Maximum reconnection attempts (${MAX_RECONNECT_ATTEMPTS}) reached. Please refresh the page.`);
      return;
    }

    let url =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_END_POINT_URL_DEV
        : process.env.REACT_APP_END_POINT_URL_PROD;

    // Create new SockJS connection
    socketRef.current = new SockJS(
      url +
        "/englishauction/connect?token=" +
        atob(sessionStorage.getItem("argument1"))
    );

    // Create STOMP client over the WebSocket
    stompClientRef.current = Stomp.over(socketRef.current);
    stompClientRef.current.debug = () => {}; 

    // Set up WebSocket close handler
    socketRef.current.onclose = () => {
      handleDisconnection();
    };

    // STOMP connection callback
    stompClientRef.current.connect({}, () => {
      console.log("Connected to WebSocket server");
      // CustomToast.success("WebSocket connection established");
      setReconnectAttempts(0); // Reset reconnect attempts on successful connection
      
      // Set up subscriptions
      subscribeCall();
      subscribeCall1();
      stompClientRef.current.send("/englishauction/send/getlotRemaining/"+auctionDetailId, {}, auctionDetailId);
    }, (error) => {
      console.error("STOMP connection error:", error);
      handleDisconnection();
    });
  };

  const handleDisconnection = () => {
    console.log("WebSocket disconnected");
    
    // Increment reconnect attempts
    setReconnectAttempts(prev => prev + 1);
    
    // Attempt reconnect if we haven't exceeded max attempts
    if (reconnectAttempts < MAX_RECONNECT_ATTEMPTS) {
      reconnectTimerRef.current = setTimeout(connectWebSocket, RECONNECT_INTERVAL);
    } else {
      CustomToast.error(`Failed to reconnect after ${MAX_RECONNECT_ATTEMPTS} attempts. Please refresh the page.`);
    }
  };

  const subscribeCall = () => {
    console.log("Subscribe Call");
    stompClientRef.current.subscribe(
      "/englishauction/broadcast/getactivedata/" + auctionDetailId,
      (message) => {
        if (message.body) {
          try {
            let json = JSON.parse(message.body);
            const [part1, part2] = json.timeSendToUI.split("-");
            console.log("Part1", part1);
            const remainingTimeInSeconds = parseInt(part1);
            setRemainingSeconds(remainingTimeInSeconds);
            stompClientRef.current.send("/englishauction/send/getheaderdata/"+auctionDetailId, {}, auctionDetailId);
          } catch(error) {
            console.error(error);
          }
        }
      }
    );
  };

  const subscribeCall1 = () => {
    console.log("Subscribe Call1");
    stompClientRef.current.subscribe(
      "/englishauction/broadcast/getlotRemaining/" + auctionDetailId,
      (message) => {
        if (message.body) {
          if (!isNaN(message.body)) {
            try {
              const remainingTimeInSeconds = parseInt(message.body);
              setRemainingSeconds(remainingTimeInSeconds);
            } catch(error) {
              console.error(error);
            }
          }
        }
      }
    );
  };

  useEffect(() => {
    // Initial connection
    connectWebSocket();

    // Cleanup function
    return () => {
      // Clear any pending reconnection attempts
      if (reconnectTimerRef.current) {
        clearTimeout(reconnectTimerRef.current);
      }
      
      // Disconnect STOMP client if it exists
      if (stompClientRef.current) {
        stompClientRef.current.disconnect();
      }
      
      // Close WebSocket if it exists
      if (socketRef.current) {
        socketRef.current.close();
      }
    };
  }, []);

  // Update remaining seconds every second
  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingSeconds(prevSeconds => prevSeconds > 0 ? prevSeconds - 1 : 0);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Convert remaining seconds to hours, minutes, and seconds
  const hours = Math.floor(remainingSeconds / 3600);
  const minutes = Math.floor((remainingSeconds % 3600) / 60);
  const seconds = remainingSeconds % 60;

  return (
    <div>
      {/* Your other JSX */}
      <div>
        <b>Active Lots : </b>
        {remainingSeconds !== 0 && (
          <>
            <span>{hours > 9 ? hours : hours < 0 ? "0" + "0" : "0" + hours}</span>:
            <span>{minutes > 9 ? minutes : minutes < 0 ? "0" + "0" : "0" + minutes}</span>:
            <span>{seconds > 9 ? seconds : seconds < 0 ? "0" + "0" : "0" + seconds}</span>
          </>
        )}
      </div>
      {/* Other parts of your JSX */}
    </div>
  );
}

export default YourComponent;